module.exports = __webpack_public_path__ + "svg/gatsby.0452cb.svg";